const lockContainer = document.querySelector('.wp-block-hs-blocks-ui-component-lock-container') || false;
const uiRootContainer = document.querySelector('.wp-block-hs-blocks-ui-root-container') || false;


lockContainer.addEventListener('pointerup', (e) => {
    if (e.target === lockContainer) {
        uiRootContainer.classList.remove('ui-nav-active', 'ui-modal-active');
    }
})